// Here is he structure of a pedigree data
export const PedigreeData = {
    data() {
        return {
            pedigreeStructure: {
                V: {
                    name: null,
                    life_id: null,
                    height: null,
                    lotBreed: null,
                    color: null,
                    primes: [],
                    horse_link: null,
                    lot_breed_id: null,
                    is_imported: null,
                    is_loaded: null,
                    has_parents: false,
                    horse_type: null,
                    is_approved: true,
                },
                VV: {
                    name: null,
                    life_id: null,
                    height: null,
                    lotBreed: null,
                    color: null,
                    primes: [],
                    horse_link: null,
                    lot_breed_id: null,
                    is_loaded: null,
                    has_parents: false,
                    horse_type: null,
                    is_approved: true,
                },
                VVV: {
                    name: null,
                    life_id: null,
                    height: null,
                    lotBreed: null,
                    color: null,
                    primes: [],
                    horse_link: null,
                    lot_breed_id: null,
                    is_loaded: null,
                    has_parents: false,
                    horse_type: null,
                    is_approved: true,
                },
                VVVV: {
                    name: null,
                    life_id: null,
                    height: null,
                    lotBreed: null,
                    color: null,
                    primes: [],
                    horse_link: null,
                    lot_breed_id: null,
                    is_loaded: null,
                    has_parents: false,
                    horse_type: null,
                    is_approved: true,
                },
                VVVM: {
                    name: null,
                    life_id: null,
                    height: null,
                    lotBreed: null,
                    color: null,
                    primes: [],
                    horse_link: null,
                    lot_breed_id: null,
                    is_loaded: null,
                    has_parents: false,
                    horse_type: null,
                    is_approved: true,
                },
                VVM: {
                    name: null,
                    life_id: null,
                    height: null,
                    lotBreed: null,
                    color: null,
                    primes: [],
                    horse_link: null,
                    lot_breed_id: null,
                    is_loaded: null,
                    has_parents: false,
                    horse_type: null,
                    is_approved: true,
                },
                VVMV: {
                    name: null,
                    life_id: null,
                    height: null,
                    lotBreed: null,
                    color: null,
                    primes: [],
                    horse_link: null,
                    lot_breed_id: null,
                    is_loaded: null,
                    has_parents: false,
                    horse_type: null,
                    is_approved: true,
                },
                VVMM: {
                    name: null,
                    life_id: null,
                    height: null,
                    lotBreed: null,
                    color: null,
                    primes: [],
                    horse_link: null,
                    lot_breed_id: null,
                    is_loaded: null,
                    has_parents: false,
                    horse_type: null,
                    is_approved: true,
                },
                VM: {
                    name: null,
                    life_id: null,
                    height: null,
                    lotBreed: null,
                    color: null,
                    primes: [],
                    horse_link: null,
                    lot_breed_id: null,
                    is_loaded: null,
                    has_parents: false,
                    horse_type: null,
                    is_approved: true,
                },
                VMV: {
                    name: null,
                    life_id: null,
                    height: null,
                    lotBreed: null,
                    color: null,
                    primes: [],
                    horse_link: null,
                    lot_breed_id: null,
                    is_loaded: null,
                    has_parents: false,
                    horse_type: null,
                    is_approved: true,
                },
                VMVV: {
                    name: null,
                    life_id: null,
                    height: null,
                    lotBreed: null,
                    color: null,
                    primes: [],
                    horse_link: null,
                    lot_breed_id: null,
                    is_loaded: null,
                    has_parents: false,
                    horse_type: null,
                    is_approved: true,
                },
                VMVM: {
                    name: null,
                    life_id: null,
                    height: null,
                    lotBreed: null,
                    color: null,
                    primes: [],
                    horse_link: null,
                    lot_breed_id: null,
                    is_loaded: null,
                    has_parents: false,
                    horse_type: null,
                    is_approved: true,
                },
                VMM: {
                    name: null,
                    life_id: null,
                    height: null,
                    lotBreed: null,
                    color: null,
                    primes: [],
                    horse_link: null,
                    lot_breed_id: null,
                    is_loaded: null,
                    has_parents: false,
                    horse_type: null,
                    is_approved: true,
                },
                VMMV: {
                    name: null,
                    life_id: null,
                    height: null,
                    lotBreed: null,
                    color: null,
                    primes: [],
                    horse_link: null,
                    lot_breed_id: null,
                    is_loaded: null,
                    has_parents: false,
                    horse_type: null,
                    is_approved: true,
                },
                VMMM: {
                    name: null,
                    life_id: null,
                    height: null,
                    lotBreed: null,
                    color: null,
                    primes: [],
                    horse_link: null,
                    lot_breed_id: null,
                    is_loaded: null,
                    has_parents: false,
                    horse_type: null,
                    is_approved: true,
                },
                M: {
                    name: null,
                    life_id: null,
                    height: null,
                    lotBreed: null,
                    color: null,
                    primes: [],
                    horse_link: null,
                    lot_breed_id: null,
                    is_imported: null,
                    is_loaded: null,
                    has_parents: false,
                    horse_type: null,
                    is_approved: true,
                },
                MV: {
                    name: null,
                    life_id: null,
                    height: null,
                    lotBreed: null,
                    color: null,
                    primes: [],
                    horse_link: null,
                    lot_breed_id: null,
                    is_loaded: null,
                    has_parents: false,
                    horse_type: null,
                    is_approved: true,
                },
                MVV: {
                    name: null,
                    life_id: null,
                    height: null,
                    lotBreed: null,
                    color: null,
                    primes: [],
                    horse_link: null,
                    lot_breed_id: null,
                    is_loaded: null,
                    has_parents: false,
                    horse_type: null,
                    is_approved: true,
                },
                MVVV: {
                    name: null,
                    life_id: null,
                    height: null,
                    lotBreed: null,
                    color: null,
                    primes: [],
                    horse_link: null,
                    lot_breed_id: null,
                    is_loaded: null,
                    has_parents: false,
                    horse_type: null,
                    is_approved: true,
                },
                MVVM: {
                    name: null,
                    life_id: null,
                    height: null,
                    lotBreed: null,
                    color: null,
                    primes: [],
                    horse_link: null,
                    lot_breed_id: null,
                    is_loaded: null,
                    has_parents: false,
                    horse_type: null,
                    is_approved: true,
                },
                MVM: {
                    name: null,
                    life_id: null,
                    height: null,
                    lotBreed: null,
                    color: null,
                    primes: [],
                    horse_link: null,
                    lot_breed_id: null,
                    is_loaded: null,
                    has_parents: false,
                    horse_type: null,
                    is_approved: true,
                },
                MVMV: {
                    name: null,
                    life_id: null,
                    height: null,
                    lotBreed: null,
                    color: null,
                    primes: [],
                    horse_link: null,
                    lot_breed_id: null,
                    is_loaded: null,
                    has_parents: false,
                    horse_type: null,
                    is_approved: true,
                },
                MVMM: {
                    name: null,
                    life_id: null,
                    height: null,
                    lotBreed: null,
                    color: null,
                    primes: [],
                    horse_link: null,
                    lot_breed_id: null,
                    is_loaded: null,
                    has_parents: false,
                    horse_type: null,
                    is_approved: true,
                },
                MM: {
                    name: null,
                    life_id: null,
                    height: null,
                    lotBreed: null,
                    color: null,
                    primes: [],
                    horse_link: null,
                    lot_breed_id: null,
                    is_loaded: null,
                    has_parents: false,
                    horse_type: null,
                    is_approved: true,
                },
                MMV: {
                    name: null,
                    life_id: null,
                    height: null,
                    lotBreed: null,
                    color: null,
                    primes: [],
                    horse_link: null,
                    lot_breed_id: null,
                    is_loaded: null,
                    has_parents: false,
                    horse_type: null,
                    is_approved: true,
                },
                MMVV: {
                    name: null,
                    life_id: null,
                    height: null,
                    lotBreed: null,
                    color: null,
                    primes: [],
                    horse_link: null,
                    lot_breed_id: null,
                    is_loaded: null,
                    has_parents: false,
                    horse_type: null,
                    is_approved: true,
                },
                MMVM: {
                    name: null,
                    life_id: null,
                    height: null,
                    lotBreed: null,
                    color: null,
                    primes: [],
                    horse_link: null,
                    lot_breed_id: null,
                    is_loaded: null,
                    has_parents: false,
                    horse_type: null,
                    is_approved: true,
                },
                MMM: {
                    name: null,
                    life_id: null,
                    height: null,
                    lotBreed: null,
                    color: null,
                    primes: [],
                    horse_link: null,
                    lot_breed_id: null,
                    is_loaded: null,
                    has_parents: false,
                    horse_type: null,
                    is_approved: true,
                },
                MMMV: {
                    name: null,
                    life_id: null,
                    height: null,
                    lotBreed: null,
                    color: null,
                    primes: [],
                    horse_link: null,
                    lot_breed_id: null,
                    is_loaded: null,
                    has_parents: false,
                    horse_type: null,
                    is_approved: true,
                },
                MMMM: {
                    name: null,
                    life_id: null,
                    height: null,
                    lotBreed: null,
                    color: null,
                    primes: [],
                    horse_link: null,
                    lot_breed_id: null,
                    is_loaded: null,
                    has_parents: false,
                    horse_type: null,
                    is_approved: true,
                },
            },
        }
    },

    methods: {
        // Merge a `source` object to a `target` recursively
        merge(target, source) {
            // Iterate through `source` properties and if an `Object` set property to merge of `target` and `source` properties
            for (let key of Object.keys(source)) {
                if (source[key] instanceof Object && key in target)
                    Object.assign(source[key], this.merge(target[key], source[key]))
            }

            // Join `target` and modified `source`
            Object.assign(target || {}, source)
            return target
        },
    },
}
